export const getRehydrated = (state) => state.temporary.rehydrated;
export const getJustSubmitted = (state) => state.temporary.justSubmitted;
export const getShowPasswordlessLogin = (state) => state.temporary.showPasswordlessLogin;
export const getPasswordlessEmail = (state) => state.temporary.email;
export const getEmailAlreadyExist = (state) => state.temporary.emailAlreadyExist;
export const getLinkSentToEmail = (state) => state.temporary.linkSentToEmail;
export const getSendLoginLinkError = (state) => state.temporary.sendLoginLinkError;
export const getLoginLinkStatus = (state) => state.temporary.loginLinkStatus;
export const getCheckingLoginLinkStatus = (state) => state.temporary.checkingLoginLinkStatus;